import { Fragment, useEffect } from 'react'
import { NextSeo } from 'next-seo'

import withPage from '@/lib/page/withPage'

import withServiceLayout from '@/features/Services/layouts/withServiceLayout'
import ServiceSection from '@/features/Services/templates/ServiceSection'
import PriceSection from '@/features/Services/templates/PriceSection'

import { WhatYouGet } from '@/components/Landing'

import { COOKIE } from '@/features/Services/constants'
import { logEcommerce } from '@/lib/stats/gtm'

function Cookie() {
  useEffect(() => {
    logEcommerce('view_item', {
      items: [
        {
          item_id: 'Cookie Policy',
          item_name: 'Cookie Policy',
          quantity: 1,
        },
      ],
    })
  }, [])
  return (
    <Fragment>
      <NextSeo title="Cookie Policy" />

      <ServiceSection data={COOKIE} />
      <PriceSection serviceName="COOKIE" />
      <WhatYouGet hideDecor primaryColor={COOKIE.PRIMARY_COLOR} />
    </Fragment>
  )
}

export default withPage()(withServiceLayout(Cookie))
